import { Component, input , OnInit, inject, signal, WritableSignal} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AbsoluteMediaUriService } from '../../../../../services/absolute-media-uri.service';
import { ApiService } from '../../../../../services/api.service';
import { IBidder } from '../../../../../models/IBidder';
import { SlicePipe, CurrencyPipe } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-auction-homepage-top-bidders',
  imports: [SlicePipe, RouterModule, CurrencyPipe],
  templateUrl: './auction-homepage-top-bidders.component.html',
  styleUrl: './auction-homepage-top-bidders.component.scss'
})
export class AuctionHomepageTopBiddersComponent implements OnInit{
  private readonly apiService = inject(ApiService)
  private readonly sanitizer = inject(DomSanitizer);
  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);

  public auctionId = input(0);

  topBidders: WritableSignal<IBidder[] | null> = signal(null);

  ngOnInit(): void {
    this.apiService.getTopBidders( this.auctionId()).subscribe((data) => {
      this.topBidders.set(data);
    });
  }

  printFirstLetters(text: string): string {
    const words = text.split(' ');
    const firstLetters = words.map(word => word[0]);
    const joinedString = firstLetters.join("");
    return joinedString.length > 2 ? joinedString.substring(0,2) : joinedString;
  }

  protected getSafeUri(uri: string | undefined | null): SafeResourceUrl {
    if (uri != undefined && uri != null) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(uri)
    }
    return "";
  }

}
